export default __webpack_public_path__ + "static/media/app_logo_without_text.a34e6c66.png";